module.exports = __webpack_public_path__ + "img/loading.8283ae62.gif";